<template>
    <v-container fill-height>
      <v-row justify="center" align="center">
        <v-col class="text-center">
          <v-progress-circular
            indeterminate
            :color="spinnerColor"
            size="80"
            width="4"
          ></v-progress-circular>
          <p :style="{ color: textColor, marginTop: '20px', fontSize: '15px', fontWeight: '500' }" class="loading-text">{{ text }}</p>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    props: {
      text: {
        type: String,
        default: 'Loading, please wait...',
      },
      textColor: {
        type: String,
        default: 'rgb(0, 0, 0)',
      },
      spinnerColor: {
        type: String,
        default: 'primary',
      },
    }
  };
  </script>
  
  <style scoped>
  .loading-text {
    letter-spacing: -0.3px;
  }
  </style>
  